import axios from 'axios';
import { createClient } from '@supabase/supabase-js';

const IS_CLOUD = process.env.REACT_APP_DEPLOYMENT_MODE === 'cloud';
const API_BASE = IS_CLOUD
  ? (process.env.REACT_APP_API_URL || '').replace(/\/$/, '') + '/api'
  : '/api';

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: !IS_CLOUD,
});

let _supabaseClient = null;
function getSupabase() {
  if (!_supabaseClient && IS_CLOUD) {
    _supabaseClient = createClient(
      process.env.REACT_APP_SUPABASE_URL,
      process.env.REACT_APP_SUPABASE_ANON_KEY,
    );
  }
  return _supabaseClient;
}

api.interceptors.request.use(async (config) => {
  config.headers['X-Client-Hostname'] = window.location.hostname;

  if (IS_CLOUD) {
    try {
      const supabase = getSupabase();
      if (supabase) {
        const { data: { session } } = await supabase.auth.getSession();
        if (session?.access_token) {
          config.headers['Authorization'] = `Bearer ${session.access_token}`;
        }
      }
    } catch {
      // If Supabase is unavailable, request proceeds without auth header
    }
  }

  return config;
});

export default api;
